export default "__VITE_ASSET__D$GsEHcM__"